var Acre = "อาครี";
var Alagoas = "อาลาโกวัช";
var Amazonas = "อามาโซนัส";
var Bahia = "บาเยีย";
var Pernambuco = "เปร์นัมบูกู";
var Roraima = "โรไรมา";
var Sergipe = "เซร์ชิเป";
var Tocantins = "โตกันตินส์";
var PTStates = {
	Acre: Acre,
	Alagoas: Alagoas,
	"Amapá": "อามาปา",
	Amazonas: Amazonas,
	Bahia: Bahia,
	"Ceará": "เซอารา",
	"Federal District": "เฟเดอรัลดิสตริกต์",
	"Espírito Santo": "เอชปีรีตูซังตู",
	"Goiás": "โกยาช",
	"Maranhão": "มารันเญา",
	"Mato Grosso": "มาตูโกรสซู",
	"Mato Grosso do Sul": "มาตูโกรสซูโดซูล",
	"Minas Gerais": "มีนัสเจไรส์",
	"Pará": "ปารา",
	"Paraíba": "ปาราอีบา",
	"Paraná": "ปารานา",
	Pernambuco: Pernambuco,
	"Piauí": "ปีเอาอี",
	"Rio de Janeiro": "รีโอเดจาเนโร",
	"Rio Grande do Norte": "รีโอกรันดีโดนอร์เต",
	"Rio Grande do Sul": "รีโอกรันดีโดซูล",
	"Rondônia": "รอนโดเนีย",
	Roraima: Roraima,
	"Santa Catarina": "ซันตากาตารีนา",
	"São Paulo": "เซาเปาโล",
	Sergipe: Sergipe,
	Tocantins: Tocantins
};

export { Acre, Alagoas, Amazonas, Bahia, Pernambuco, Roraima, Sergipe, Tocantins, PTStates as default };
